import { Dispatch, Action } from 'redux'
import { FormSpinnerMapDispatchReturnType } from './types/FormSpinnerMapDispatchReturnType'

export const FormSpinnerMapDispatch = (
  _dispatch: Dispatch<Action>
): FormSpinnerMapDispatchReturnType => {
  return {}
}
